/**
 * The slice of the Web Serial API this app uses.
 *
 * TypeScript's DOM lib does not ship these types, so they are declared here
 * rather than pulling in @types/w3c-web-serial for five members.
 */
export type SerialPortInfo = {
  usbVendorId?: number;
  usbProductId?: number;
};

export type SerialOptions = {
  baudRate: number;
  dataBits?: number;
  stopBits?: number;
  parity?: 'none' | 'even' | 'odd';
};

export interface SerialPort extends EventTarget {
  readonly readable: ReadableStream<Uint8Array> | null;
  readonly writable: WritableStream<Uint8Array> | null;
  open(options: SerialOptions): Promise<void>;
  close(): Promise<void>;
  getInfo(): SerialPortInfo;
}

export interface Serial extends EventTarget {
  getPorts(): Promise<SerialPort[]>;
  requestPort(): Promise<SerialPort>;
}

export const getSerial = (): Serial | undefined => {
  if (typeof navigator === 'undefined') {
    return undefined;
  }
  return (navigator as Navigator & { serial?: Serial }).serial;
};
